import "./Invoice.less";
import axios from "axios";
import { Spin } from "antd";
import { getYmd } from "../../utils/format";
import { useParams } from "react-router-dom";
import React, { useCallback, useEffect, useState } from "react";
import PPPageHeader from "../pageHeader/PPPageHeader";
import { IconInformation } from "../description/information/iconInf";
import {
  FilePptOutlined,
  CalendarOutlined,
  SyncOutlined,
  DownOutlined,
} from "@ant-design/icons";

export const InvoiceDetail = () => {
  const { id } = useParams();
  const [billing, setBilling] = useState([]);
  const [invoices, setInvoices] = useState({});
  const [expandedRows, setExpandedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const routes = [
    {
      path: "/invoice-list",
      breadcrumbName: "Нэхэмжлэхүүд",
    },
    {
      path: "first",
      breadcrumbName: "Нэхэмжлэхийн дэлгэрэнгүй",
    },
  ];
  const getInvoiceDesc = useCallback(() => {
    setLoading(true);
    axios
      .get(`/api/v1/invoice/${id}`)
      .then(({ data }) => {
        if (data.statusCode === 200) {
          setInvoices(data?.result?.invoice);
          setBilling(data?.result?.billing);
          // const billingData = data?.result?.billing?.filter(bill => bill.serviceType === bill.serviceType);
        }
      })
      .catch((e) => {
        console.error("Fetch Invoice Detail: ", e);
      })
      .finally(() => setLoading(false));
  }, [id]);
  const formatCurrency = (currency) => {
    let formetedCurrency = Number(currency)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, "$&,");
    return formetedCurrency;
  };
  useEffect(() => {
    getInvoiceDesc();
  }, [getInvoiceDesc]);

  const general_inf = [
    {
      name: "Нэхэмжлэх № :",
      description: invoices?.code,
      icon: <FilePptOutlined />,
    },
    {
      name: "Нэхэмжилсэн огноо :",
      description: getYmd(invoices?.createdAt),
      icon: <CalendarOutlined />,
    },
    {
      name: "Төлөх огноо :",
      description: getYmd(invoices?.dueDate),
      icon: <CalendarOutlined />,
    },
    {
      name: "Захиалгын төлөв :",
      description: invoices?.paymentStatus,
      icon: <SyncOutlined />,
    },
  ];

  const toggleTable = (i) => {
    const expandedRowsCopy = [...expandedRows];
    expandedRowsCopy[i] = !expandedRowsCopy[i];
    setExpandedRows(expandedRowsCopy);
  };
  return (
    <div>
      <PPPageHeader
        title={"Нэхэмжлэхийн дэлгэрэнгүй"}
        breadcrumb={{
          routes,
        }}
      />
      <Spin spinning={loading}>
        <div className="invoice_container">
          <div className="general_inf">
            {general_inf?.map((el, i) => {
              return (
                <IconInformation
                  key={i}
                  title={el?.name}
                  description={el?.description}
                  icon={el?.icon}
                />
              );
            })}
          </div>
          <div>
            <table className="invoice__dtl__table">
              <thead>
                <tr>
                  <th className="short__th"></th>
                  <th>Үйлчилгээний төрөл</th>
                  <th>Тоо хэмжээ</th>
                  <th>НӨАТ-гүй дүн</th>
                  <th className="short__th"></th>
                </tr>
              </thead>
              <tbody>
                {billing?.map((e, i) => {
                  const { mainBill, invoiceSub } = e || {};
                  return (
                    <React.Fragment key={i}>
                      <tr>
                        <td className="short__th">
                          <span>0{i + 1}</span>
                        </td>
                        <td>{mainBill?.serviceName}</td>
                        <td>{mainBill?.totalCount}</td>
                        <td className="blue">
                          {formatCurrency(mainBill?.totalPrice)}
                        </td>
                        <td className="short__th">
                          {invoiceSub ? (
                            <DownOutlined
                              style={{ fontSize: "12px" }}
                              onClick={() => toggleTable(i)}
                            />
                          ) : (
                            ""
                          )}
                        </td>
                      </tr>
                      {expandedRows[i] &&
                        invoiceSub?.map((e, i) => {
                          const { positionCode, count, amount } = e || {};
                          return (
                            <tr className="grey">
                              <td className="short__th"></td>
                              <td>{positionCode}</td>
                              <td>{count}</td>
                              <td>{formatCurrency(amount)}</td>
                              <td className="short__th"></td>
                            </tr>
                          );
                        })}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
            <div className="amount_container">
              <div className="invoice_actual_amount">
                <p>Нийт дүн /НӨАТ-гүй/</p>
                <p>{formatCurrency(invoices?.actualAmount)}</p>
              </div>
              <div className="invoice_actual_amount">
                <p>НӨАТ 10%</p>
                <p>{formatCurrency(invoices?.tax)}</p>
              </div>
              <div className="invoice_amount">
                <p>Нийт дүн /НӨАТ-тай/</p>
                <p>{formatCurrency(invoices?.amount)}</p>
              </div>
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

/* <Table
key={dataColls?.key}
columns={dataColls}
dataSource={billing}
pagination={false}
scroll={{
  x: true,
}}
expandable={{
  expandedRowRender: (record) => {
    return (
      <Table
        key={childColls?.key}
        showHeader={false}
        pagination={false}
        columns={childColls}
        dataSource={record?.invoiceSub}
      />
    );
  },
  //   rowExpandable: (record) => record?.invoiceSub,
}}
/> */
